import { Link } from "react-router-dom";
import { ShieldX } from "lucide-react";

import { Button } from "@/components/ui/button";

/** T94 — 403 Không có quyền. */
export function ForbiddenPage() {
  return (
    <div className="flex justify-center px-6 py-16">
      <div className="w-full max-w-lg rounded-md border bg-card p-8 text-center shadow-sm">
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-destructive/10 text-destructive">
          <ShieldX className="h-7 w-7" aria-hidden="true" />
        </div>
        <div className="text-5xl font-bold text-destructive">403</div>
        <h1 className="mt-2 text-xl font-semibold text-foreground">
          Bạn không có quyền truy cập
        </h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Tài khoản của bạn chưa được cấp quyền cho chức năng này. Vui lòng liên
          hệ quản trị viên phòng khám để được phân quyền.
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-2">
          <Button asChild>
            <Link to="/dashboard">Về Dashboard</Link>
          </Button>
          <Button asChild variant="secondary">
            <Link to="/me/profile">Xem hồ sơ</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
